import { ErrorBoundary } from '@intrasync/react';
import { LayoutRouter } from './components/LayoutProvider';
import React from 'react';

const App: React.FC = () => {
  return (
    <ErrorBoundary isLayout name="LayoutRouter">
      <LayoutRouter />
    </ErrorBoundary>
  );
};

export default App;
